export const CONFIG = {
    API_URL: import.meta.env.VITE_API_URL || 'http://localhost:7777',
    APP_URL: import.meta.env.VITE_APP_URL || 'http://localhost:3000',
    COOKIE_DOMAIN: import.meta.env.VITE_COOKIE_DOMAIN || 'localhost',
};